export const LOAD_ALL_ACTIVITIES = 'LOAD_ALL_ACTIVITIES';
export const LOAD_ALL_ACTIVITIES_FAILED = 'LOAD_ALL_ACTIVITIES_FAILED';

export const LOAD_CUSTOMERS = 'LOAD_CUSTOMERS';
export const LOAD_CUSTOMERS_FAILED = 'LOAD_CUSTOMERS_FAILED';

export const LOAD_WORK_ORDERS = 'LOAD_WORK_ORDERS';
export const LOAD_WORK_ORDERS_SUCCESS = 'LOAD_WORK_ORDERS_SUCCESS';
export const LOAD_WORK_ORDERS_FAILED = 'LOAD_WORK_ORDERS_FAILED';


export const GET_USER_CHECKIN = 'GET_USER_CHECKIN';
export const GET_USER_CHECKIN_FAILED = 'GET_USER_CHECKIN_FAILED';
export const CHECK_IN_USER = 'CHECK_IN_USER';
export const CHECK_IN_USER_FAILED = 'CHECK_IN_USER_FAILED';
export const DELETE_CHECKIN = 'DELETE_CHECKIN';
export const UPDATE_CHECKIN_WORKDAY = 'UPDATE_CHECKIN_WORKDAY';

export const START_ACTIVITY = 'START_ACTIVITY';
export const UPDATE_ACTIVITY = 'UPDATE_ACTIVITY';
export const UPDATE_ACTIVITY_DURATION = 'UPDATE_ACTIVITY_DURATION';
export const GET_CURRENT_ACTIVITY = 'GET_CURRENT_ACTIVITY';
export const DELETE_ACTIVITY = 'DELETE_ACTIVITY';

export function loadAllActivities(data) {
    return {
        type: LOAD_ALL_ACTIVITIES,
        payload: data,
    }
}

export function loadAllActivitiesFailed(data) {
    return {
        type: LOAD_ALL_ACTIVITIES_FAILED,
        payload: data,
    }
}

export function loadCustomers(data) {
    return {
        type: LOAD_CUSTOMERS,
        payload: data,
    }
}

export function loadCustomersFailed(data) {
    return {
        type: LOAD_CUSTOMERS_FAILED,
        payload: data,
    }
}

export function loadWorkOrders(data) {
    return {
        type: LOAD_WORK_ORDERS,
        payload: data
    }
}

export function loadWorkOrdersSuccess(data) {
    return {
        type: LOAD_WORK_ORDERS,
        payload: data
    }
}

export function loadWorkOrdersFailed(data) {
    return {
        type: LOAD_WORK_ORDERS_FAILED,
        payload: data
    }
}

export function checkInUser(data) {
    return {
        type: CHECK_IN_USER,
        payload: data,
    }
}

export function checkInUserFailed(data) {
    return {
        type: CHECK_IN_USER_FAILED,
        payload: data,
    }
}

export function getUserCheckin(data) {
    return {
        type: GET_USER_CHECKIN,
        payload: data,
    }
}

export function getUserCheckinFailed(data) {
    return {
        type: GET_USER_CHECKIN_FAILED,
        payload: data,
    }
}

export function startActivity(data) {
    return {
        type: START_ACTIVITY,
        payload: data
    }
}

export function updateActivity(data) {
    return {
        type: UPDATE_ACTIVITY,
        payload: data
    }
}

export function getCurrentActivity(data) {
    return {
        type: GET_CURRENT_ACTIVITY,
        payload: data
    }
}

export function deleteCheckin(data) {
  return {
    type: DELETE_CHECKIN,
    payload: data,
  }
}

export function updateCheckinWorkday(data) {
  return {
    type: UPDATE_CHECKIN_WORKDAY,
    payload: data
  }
}



// WEBPACK FOOTER //
// ./src/actions/checkIn/index.js